var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 24,
  fill: "none",
  viewBox: "0 0 28 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.25 3.553h3.068C26.391 3.553 28 5.138 28 7.105v13.342C28 22.36 26.298 24 24.318 24H3.682C1.719 24 0 22.341 0 20.447V7.105c0-1.894 1.719-3.552 3.682-3.552H6.75l.691-1.93Q7.707.96 8.415.48T9.865 0h8.176q.742 0 1.45.48t.974 1.143z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#515DAD",
  strokeWidth: 2,
  d: "M19 13.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
})));
export default SvgCamera;